import { render } from "./RemoteController.vue?vue&type=template&id=1e413ef8&scoped=true"
import script from "./RemoteController.vue?vue&type=script&lang=js"
export * from "./RemoteController.vue?vue&type=script&lang=js"

import "./RemoteController.vue?vue&type=style&index=0&id=1e413ef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e413ef8"]])

export default __exports__